// extracted by mini-css-extract-plugin
module.exports = {"socialandDownloadLinksWrapper":"styles_socialandDownloadLinksWrapper__WlDYZ","Wrapper":"styles_Wrapper__jGfy9","iconLayout":"styles_iconLayout__DNSmE","title":"styles_title__Ee0tO","DownloadLinks":"styles_DownloadLinks__Bbdzv","text":"styles_text__4__4Q","line":"styles_line__FkTDn"};
module.exports.__checksum = "3edc0659711a"
